import { Box, Tooltip } from '@mantine/core'
import { type ReactQuery } from 'cms-api'
import React, { useEffect, useState } from 'react'
import { scroller } from 'react-scroll'
import { type ImageSize } from './types'

export const ResultLabels = ({
  labels = [],
  imageSize,
  onHovering,
}: {
  labels?: ReactQuery.ImageSearchLabelsItem[]
  imageSize: ImageSize
  onHovering: (index: number | undefined) => void
}) => {
  const [hoveringIndex, setHoveringIndex] = useState<number | undefined>()

  useEffect(() => {
    onHovering(hoveringIndex)
  }, [hoveringIndex, onHovering])

  return (
    <Box
      pos="absolute"
      top={0}
      left={0}
      w="100%"
      h="100%"
      style={{ pointerEvents: 'none' }}
    >
      <style>{`
        @keyframes pulseRing {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.6);
            opacity: 0.4;
          }
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }
      `}</style>

      {labels?.map((embedding, idx) => {
        const leftPx = embedding.boundingBox.left * imageSize.width
        const topPx = embedding.boundingBox.top * imageSize.height
        const widthPx = embedding.boundingBox.width * imageSize.width
        const heightPx = embedding.boundingBox.height * imageSize.height
        const centerX = leftPx + widthPx / 2
        const centerY = topPx + heightPx / 2

        return (
          <Tooltip
            key={idx}
            label={embedding.name}
            withArrow
            openDelay={100}
            withinPortal
            style={{
              fontWeight: 'bold',
              background: '#126554',
              color: 'white',
            }}
          >
            <Box
              style={{
                position: 'absolute',
                left: centerX - 16,
                top: centerY - 16,
                width: 32,
                height: 32,
                pointerEvents: 'auto',
                cursor: 'pointer',
              }}
              onClick={() =>
                scroller.scrollTo(`${embedding.name}-${idx}`, {
                  duration: 20,
                  delay: 0,
                  smooth: 'easeInOutQuart',
                  offset: -100,
                })
              }
              onMouseOver={() => setHoveringIndex(idx)}
              onMouseOut={() => setHoveringIndex(undefined)}
            >
              {/* First pulse ring */}
              <Box
                style={{
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '50%',
                  backgroundColor: 'rgba(18, 101, 84, 0.45)',
                  animation: 'pulseRing 1.5s ease-out infinite',
                  transformOrigin: 'center',
                }}
              />

              {/* Inner static circle */}
              <Box
                style={{
                  position: 'absolute',
                  inset: '6px',
                  borderRadius: '50%',
                  backgroundColor: '#126554',
                  zIndex: 5,
                  opacity: 0.9,
                  border: '2px solid white',
                }}
              />
            </Box>
          </Tooltip>
        )
      })}
    </Box>
  )
}
